import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import * as DataFormat from '../../../../../../Common/Scripts';

const linkFormatter = (cell, row, rowIndex, formatExtraData) => {
	return (
		<button
			aria-label={`Select to view Appointees for Team ${row.title}`}
			className="btn btn-primary btn-sm"
			style={{ width: '130px' }}
		>
		View Appointees
	</button>
	);
};

const TeamsColumns = () => [
	{ dataField: 'id_type', text: 'id_type', hidden: true, csvExport: false },
	{ 
		dataField: 'button', 
		formatter: linkFormatter,
		headerClasses: 'th-appointees-select-td',
		classes: 'tr-td-overflow-hide',
		isDummyField: true,
        text: 'View Appointees'
	},
	{
		dataField: 'qualificationYear',
		text: 'Qual Year',
		editable: false,
		headerClasses: 'th-td-ssx',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'type',
		text: 'Appt Type',
		editable: false,
		headerClasses: 'th-td-ssx',
		classes: 'tr-td-overflow-hide'
	},
	{ dataField: 'markingTeamId', text: 'ID', hidden: true },
	{
		dataField: 'title',
		text: 'Marking Team Title',
		headerClasses: 'th-auto-td',
		sort: true,
		editable: false
	},
	{
		dataField: 'markingTeamCode',
		text: 'Marking Team Code',
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		sort: true,
		editable: false,
		csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
	},
	{
		dataField: 'markingMethod',
		text: 'Marking Method',
		headerClasses: 'th-title-td',
		sort: true,
		editable: false
	}
];

export const keyField = 'id_type';
export default TeamsColumns;
